import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Services = () => {
  const location = useLocation();

  const services = [
    {
      id: "audit",
      icon: "fas fa-search",
      num: "01",
      title: "Audit & Diagnostic",
      desc: "Analyse complète de vos installations électriques, évaluation des risques et définition des besoins spécifiques pour optimiser votre système de courant faible."
    },
    {
      id: "etudes",
      icon: "fas fa-drafting-compass",
      num: "02",
      title: "Études & Conception",
      desc: "Dimensionnement technique, conception de schémas électriques et plans d'exécution optimisés pour garantir la performance et la conformité."
    },
    {
      id: "installation",
      icon: "fas fa-hard-hat",
      num: "03",
      title: "Installation",
      desc: "Pose professionnelle, câblage et mise en service par nos équipes certifiées sur l'ensemble du territoire marocain."
    },
    {
      id: "maintenance",
      icon: "fas fa-tools",
      num: "04",
      title: "Maintenance",
      desc: "Contrats de maintenance préventive et corrective pour assurer la pérennité et la disponibilité de vos équipements 24h/24."
    },
    {
      id: "controle",
      icon: "fas fa-clipboard-check",
      num: "05",
      title: "Contrôle & Vérification",
      desc: "Vérification périodique de conformité aux normes en vigueur, rapports détaillés et recommandations d'amélioration."
    },
    {
      id: "conseil",
      icon: "fas fa-lightbulb",
      num: "06",
      title: "Conseil & Études",
      desc: "Accompagnement personnalisé dans le choix de vos solutions, études de faisabilité et optimisation de vos investissements."
    }
  ];

  useEffect(() => {
    const hash = location.hash ? location.hash.replace('#', '') : '';
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const getHeaderOffset = () => {
      const topBar = document.querySelector('.hdr-top');
      const main = document.querySelector('.hdr-main');
      const h =
        (topBar ? topBar.getBoundingClientRect().height : 0) +
        (main ? main.getBoundingClientRect().height : 0);
      return h ? h + 16 : 110;
    };

    let raf1, raf2, timeoutId, highlightTimer;

    const scrollToTarget = () => {
      const target = document.getElementById(hash);
      if (!target) return;
      const offset = getHeaderOffset();
      const y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      target.classList.add('sv-block--highlight');
      highlightTimer = setTimeout(
        () => target.classList.remove('sv-block--highlight'),
        2000
      );
    };

    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        timeoutId = setTimeout(scrollToTarget, 60);
      });
    });

    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
      clearTimeout(timeoutId);
      clearTimeout(highlightTimer);
    };
  }, [location]);

  return (
    <div className="sv-page">
      {/* Hero + Services intégrés */}
      <section className="sv-hero">
        <div className="container">
          <div className="sv-hero-top">
            <div className="sv-hero-text">
              <span className="sv-hero-label">Ce que nous faisons</span>
              <h1>Nos <span className="hdr-green">Services</span></h1>
              <p>De l'audit à la maintenance, nous vous accompagnons à chaque étape de vos projets en courant faible.</p>
            </div>
            <div className="sv-hero-stats">
              <div><strong>+13</strong><span>Ans d'expérience</span></div>
              <div><strong>500+</strong><span>Projets livrés</span></div>
              <div><strong>24h</strong><span>Intervention</span></div>
            </div>
          </div>

          {/* Services grid */}
          <div className="sv-grid">
            {services.map((s, i) => (
              <div key={i} id={s.id} className="sv-block">
                <div className="sv-block-head">
                  <div className="sv-block-icon"><i className={s.icon}></i></div>
                  <span className="sv-block-num">{s.num}</span>
                </div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Domaines */}
      <section className="sv-domains">
        <div className="container">
          <h2>Nos domaines d'<span className="hdr-green">intervention</span></h2>
          <div className="sv-domains-grid">
            {[
              { icon: 'fas fa-fire', label: 'Détection incendie' },
              { icon: 'fas fa-bolt', label: 'Éclairage sécurité' },
              { icon: 'fas fa-car-battery', label: 'Onduleurs' },
              { icon: 'fas fa-camera', label: 'Vidéosurveillance' },
              { icon: 'fas fa-fingerprint', label: 'Contrôle d\'accès' },
              { icon: 'fas fa-shield-alt', label: 'Alarmes intrusion' },
              { icon: 'fas fa-project-diagram', label: 'Réseaux informatiques' },
              { icon: 'fas fa-smog', label: 'Détection de gaz' },
            ].map((d, i) => (
              <div key={i} className="sv-domain">
                <i className={d.icon}></i>
                <span>{d.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="sv-cta">
        <div className="container">
          <div className="sv-cta-inner">
            <h2>Besoin d'un service sur mesure ?</h2>
            <p>Contactez notre équipe pour discuter de votre projet et obtenir un devis personnalisé.</p>
            <div className="sv-cta-btns">
              <Link to="/contact" className="sv-btn-green"><i className="far fa-paper-plane"></i> Demander un devis</Link>
              <a href="tel:0522340659" className="sv-btn-outline"><i className="fas fa-phone-volume"></i> 05 22 34 06 59</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
